<template>
  <el-main :class="{ main: collapse }">
    <keep-alive :include="['mailMagazineSend']">
      <router-view
        @callCinema="getCinemaData"
        ref="roterView"
        v-if="isRouterAlice"
      ></router-view>
    </keep-alive>
    
    <el-dialog
      :title="dialog.title"
      :show-close="false"
      :visible.sync="dialog.visible"
      :close-on-click-modal="false"
      width="500px"
      class="head-cinema"
    >
      <el-form>
        <el-select v-model="dialog.cinemaId">
          <el-option
            v-for="cinema in cinemaObj"
            :key="cinema.id"
            :value="cinema.id"
            :label="cinema.name"
          ></el-option>
        </el-select>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button class="egl-btn-white" @click="dialog.visible = false">
          {{ $locale("global.cancel") }}
        </el-button>
        <el-button class="egl-btn-yellow" v-if="dialog.cinemaId" @click="setCinema_fn">
          {{ $locale("global.confirm") }}
        </el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "main-container",
  props: {
    collapse: Boolean,
    isRouterAlice: Boolean,
  },
  data() {
    return {
      sonFunctionName: "",
      dialog: {
        title: this.$locale("global.dialog.confirmCinemas"),
        visible: false,
        cinemas: [],
        cinemaId: ""
      },
    };
  },
  computed: {
    ...mapState("app", {
      cinemaObj: state => state.cinemaObj,
    }),
  },
  methods: {
    ...mapActions("app", [
      "setAppData",
    ]),
    getCinemaData(funcName = "") {
      this.sonFunctionName = funcName;
      this.dialog.visible = true;
    },
    setCinema_fn() {
      this.setAppData({
        data: { cinemaId: this.dialog.cinemaId },
        isSupplement: true,
      });
      // localStorage.set("cinemaId", this.dialog.cinemaId);
      this.dialog.visible = false;

      if (this.sonFunctionName !== "") {
        this.$refs.roterView[this.sonFunctionName]();
        this.sonFunctionName = "";
      }
    },
  },
};
</script>
